import { CustomPreloader, MMButton } from '@components'
import cn from '@integrations/classnames'
import { useContext } from '@integrations/react'
import styles from '@requests/scss/limits.module.scss'
import { useFetchExpenseLimitsQuery } from 'mmfintech-backend-api'
import type { ExpenseLimitResponse } from 'mmfintech-backend-api/types'
import { GlobalContext, isValidArray, tr } from 'mmfintech-commons'
import { MMTableView, NoElementsMessage } from 'mmfintech-portal-commons'
import ChangeLimitModal from '../ChangeLimitModal'
import SpendingLimitBar from '../SpendingLimitBar'

function LimitsTable() {
  const { modalShow } = useContext(GlobalContext)

  const { data: expenseLimits, isFetching } = useFetchExpenseLimitsQuery(null)

  function handleChangeLimit(id: number, name: string, currency: string, monthlyVolume: number) {
    modalShow({
      options: { closeOnClickOutside: false, size: 'auto' },
      content: (
        <ChangeLimitModal
          merchantUserId={id}
          merchantUserName={name}
          currency={currency}
          monthlyVolume={monthlyVolume || 0}
        />
      )
    })
  }

  return (
    <div
      className={cn(
        styles['limits-wrapper'],
        'limits-wrapper',
        'table-head-text-sm',
        'table-body-text-sm',
        'table-body-transparent'
      )}
    >
      {isFetching ? (
        <CustomPreloader />
      ) : isValidArray(expenseLimits) ? (
        <MMTableView.Table skipHover>
          <MMTableView.Head>
            <MMTableView.Row>
              <MMTableView.HeadCell>{tr('FRONTEND.LIMITS.COLUMNS.NAME', 'Name')}</MMTableView.HeadCell>
              <MMTableView.HeadCell>{tr('FRONTEND.LIMITS.COLUMNS.LIMITS', 'Limits')}</MMTableView.HeadCell>
              <MMTableView.HeadCell />
            </MMTableView.Row>
          </MMTableView.Head>
          <MMTableView.Body>
            {expenseLimits?.map((limit: ExpenseLimitResponse, index: number) => (
              <MMTableView.Row key={index} data-test='table-row'>
                <MMTableView.Cell data-test='limit-name'>
                  <div className={cn(styles['limit-name'], 'limit-name')}>{limit?.merchantUserName}</div>
                </MMTableView.Cell>
                <MMTableView.Cell data-test='limit-value'>
                  <SpendingLimitBar totalAmount={limit?.monthlyVolume} spentMonthlyVolume={limit?.spentMonthlyVolume} />
                </MMTableView.Cell>
                <MMTableView.Cell className={cn('preview-cell small')}>
                  <MMButton
                    type='button'
                    variant='security'
                    caption={tr('FRONTEND.LIMITS.BUTTON_CHANGE', 'Change limit')}
                    onClick={() =>
                      handleChangeLimit(
                        limit?.merchantUserId,
                        limit?.merchantUserName,
                        limit?.currency,
                        limit?.monthlyVolume
                      )
                    }
                    className={cn('details-button')}
                    data-test='details-button'
                  />
                </MMTableView.Cell>
              </MMTableView.Row>
            ))}
          </MMTableView.Body>
        </MMTableView.Table>
      ) : (
        <NoElementsMessage message={tr('FRONTEND.LIMITS.NO_LIMITS_MESSAGE', 'No limits yet')} />
      )}
    </div>
  )
}

export default LimitsTable
